import { IRequest } from '@r1-frontend/shared/types/IRequest';

import type { RequestDto } from './dto/RequestDto';

/**
 * Swagger: https://master.api-profile.sandbox.d2c.r-one.io/docs/v2#/TvPackets/4df0e847fabdc0d16f02c1b25ef5f79a
 * Connets specified TV packet
 *
 * @param requestBody
 * @returns Existing and available TV packets for connection
 */
const setTvPackets = (requestBody: RequestDto): IRequest => ({
    uri: '/v2/tv-packets/set-tv-packet',
    method: 'POST',
    withProvider: true,
    withAuth: true,
    body: JSON.stringify(requestBody),
});

export type { RequestDto };
export type { ResponseDto } from './dto/ResponseDto';

export default setTvPackets;
